import React from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4 group">
              <img 
                src="/logo.png" 
                alt="Velmora Holidays Logo" 
                width="84"
                height="56"
                loading="lazy"
                decoding="async"
                className="h-14 w-auto transition-transform group-hover:scale-105"
              />
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              Your trusted travel partner for exploring the magnificent beauty of Kashmir.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-amber-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/destinations" className="text-sm hover:text-amber-500 transition-colors">
                  Destinations
                </Link>
              </li>
              <li>
                <Link to="/packages" className="text-sm hover:text-amber-500 transition-colors">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-amber-500 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-amber-500 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-sm hover:text-amber-500 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-sm hover:text-amber-500 transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm hover:text-amber-500 transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm hover:text-amber-500 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-sm hover:text-amber-500 transition-colors">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.location}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div className="flex flex-col space-y-1">
                  <a href="tel:+919419016969" className="text-sm hover:text-amber-500 transition-colors" data-testid="footer-phone-1">+91 9419016969</a>
                  <a href="tel:+919419016969" className="text-sm hover:text-amber-500 transition-colors" data-testid="footer-phone-2">+91 9419016969</a>
                  <a href="tel:+919186360920" className="text-sm hover:text-amber-500 transition-colors" data-testid="footer-phone-3">+91 9186360920</a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{companyInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-white font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/velmoraholidays/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-slate-700 rounded-full hover:bg-amber-600 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
            <p className="text-sm text-gray-400 mt-4">
              Stay updated with our latest packages and travel tips!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Velmora Holidays. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};